import type { ReactElement } from "react";

import { SWReactCountryIcons } from "@similarweb/icons";

import type { IntentCountryScopeDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";

import {
    StyledCitiesTooltipContainer,
    StyledCountryTooltipContainer,
    StyledIntentCountryIcon,
    StyledIntentTooltipContentWrapper,
    StyledIntentTooltipRowCountry,
} from "./styles";

type Props = {
    item: Readonly<IntentCountryScopeDto>;
};

const CountryListItem = ({ item }: Props) => {
    const getCountryWithCitiesContainer = (countryScope: IntentCountryScopeDto): ReactElement => {
        if (countryScope.cities.length > 0) {
            return (
                <StyledIntentTooltipRowCountry>
                    <StyledCountryTooltipContainer>{countryScope.country}:&nbsp;</StyledCountryTooltipContainer>
                    <StyledCitiesTooltipContainer>{countryScope.cities.join(", ")}</StyledCitiesTooltipContainer>
                </StyledIntentTooltipRowCountry>
            );
        }

        return <StyledIntentTooltipRowCountry>{countryScope.country}</StyledIntentTooltipRowCountry>;
    };

    return (
        <StyledIntentTooltipContentWrapper key={item.countryCode}>
            <StyledIntentCountryIcon>
                <SWReactCountryIcons
                    countryCode={item.countryCode}
                    size="xs"
                />
            </StyledIntentCountryIcon>

            {getCountryWithCitiesContainer(item)}
        </StyledIntentTooltipContentWrapper>
    );
};

export default CountryListItem;
